import { defineMessages } from 'react-intl';

export const vehicleMessages = defineMessages({
    inParking: {
        id: 'in-parking',
        defaultMessage: 'In parking',
    },
    fullLog: {
        id: 'full-log',
        defaultMessage: 'Full log',
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Reservations',
    },
    subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions',
    },
});
